import { APIS } from '@/constants';
import { apisUtility } from '@/utils';
import axios from 'axios';

const usersApi = {
  /**
   *
   * @param {String} token
   * @param {Object} parameters
   * @returns {AxiosPromise}
   */
  requestList(token, parameters) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const params = apisUtility.bindValuedParams(parameters);
    return axios({
      method: 'get',
      baseURL: APIS.BASE_URL.USERS,
      headers,
      params,
    });
  },
};

export default usersApi;
